import React, {Component} from 'react';

/*global google*/
/*eslint no-undef: "error"*/

class BasicStreetMap extends Component {
    componentDidMount() {
        let map = new google.maps.Map(this.refs.mapContainer, {
            center: this.props.location,
            scrollwheel: false,
            mapTypeControl: false,
            zoom: 15
        });
        new google.maps.Marker({
            map: map,
            position: this.props.location
        });
    }

    render() {
        return (
            <div style={{height: this.props.height, width: this.props.width, ...this.props.style}} ref="mapContainer" />
        )
    }
}

BasicStreetMap.defaultProps = {width: "100%"};

export default BasicStreetMap;


// WEBPACK FOOTER //
// ./src/components/media/maps/BasicStreetMap.js